import React from 'react';
import { FaLaptopCode, FaSearch, FaMousePointer, FaFacebookF } from 'react-icons/fa';
import './Services.css';

const Services = () => {
  const services = [
    {
      id: 1,
      icon: <FaLaptopCode />,
      title: 'Web Design & Development',
      description: 'Creating stunning websites that leave a lasting impression. From simple informational sites to complex e-commerce platforms, we deliver excellence.'
    },
    {
      id: 2,
      icon: <FaSearch />,
      title: 'SEO (Search Engine Optimization)',
      description: 'Boost your visibility and rank higher on search engines. We help your business get discovered by the right audience at the right time.'
    },
    {
      id: 3,
      icon: <FaMousePointer />,
      title: 'Pay-Per-Click (PPC) Advertising',
      description: 'Instant traffic, immediate results. We manage your ad spend to maximize ROI, targeting customers actively searching for your services.'
    },
    {
      id: 4,
      icon: <FaFacebookF />,
      title: 'Facebook & Instagram Ads',
      description: 'Engage your audience on social platforms. We create scroll-stopping ad campaigns that drive brand awareness, engagement, and conversions.'
    }
  ];

  return (
    <section className="services" id="services">
      <div className="container">
        <div className="services-header">
          <span className="section-tag">Our Awesome Services</span>
          <h2 className="section-title">
            We Are <span className="highlight">Dedicated</span> To<br/>Serve You All Time.
          </h2>
        </div>

        <div className="services-grid">
          {services.map((service) => (
            <div className="service-card" key={service.id}>
              <div className="service-icon-container">
                <div className="service-icon">{service.icon}</div>
                <div className="service-icon-bg"></div>
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
